import { styled, Theme } from '@mui/material/styles';
import { Stack, FormLabel, Typography } from '@mui/material';

export const ConfirmItem = styled(Stack)(({ theme }: { theme: Theme }) => ({
  flexDirection: 'row',
  width: '100%',
  alignItems: 'flex-start',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export const ConfirmItemLabel = styled(FormLabel)`
  min-width: 150px;
  font-family: 'YuGothic';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #505050;
  line-height: 30px;
  display: flex;
  align-items: center;

  .MuiFormLabel-asterisk {
    font-weight: bold;
    color: #ff0000;
  }  
`;

export const ConfirmItemValue = styled(Typography)`
  width: 100%;
  font-family: 'YuGothic';
  font-style: normal;
  font-weight: 700;
  font-size: 19px;
  line-height: 33px;
  color: #505050;
`;

export const ConfirmItemAlert = styled(Typography)`
  font-family: 'YuGothic';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #E74C3C;
  display: block;
  line-height: 33px;
`;
